angular.module('zc.commonApi')

.factory 'ProjectThumbnailSelector', ($resource, $q, BaseProjectCrudService) ->
  class ProjectThumbnailSelector extends BaseProjectCrudService

  new ProjectThumbnailSelector(
    $resource
    $q
    '/api/master/projects/:projectId/thumbnail_selectors/:id'
    'thumbnail_selector'
    'thumbnail_selectors'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/thumbnail_selector.service.coffee